import { sessionStorageApiDomain } from '../constants';
import { getFileExtension } from '../utils/file';

export interface OpenInDesktopServiceProps {
	wopiUrl: string;
	userId: string;
	fileName: string;
}

const scheme = (fileName: string) => {
	const extension = getFileExtension(fileName);
	switch (extension) {
		case 'docm':
		case 'docx':
		case 'odt':
		default:
			return 'ms-word';
	}
};

const serviceIdentifier = () => {
	const domain = sessionStorage.getItem(sessionStorageApiDomain)?.split('.')[0];
	switch (domain) {
		case 'sf-api':
			return 'TP_SHAREFILE_PLUS';
		case 'sf-apitest':
		case 'sf-apistaging':
		default:
			return 'TP_SHAREFILE_QA_TEST';
	}
};

const SpawnMicrosoftOfficeWithWopi = (props: OpenInDesktopServiceProps) => {
	const openInDesktopUrl =
		scheme(props.fileName) +
		':' +
		'ofe' +
		'|u|' +
		props.wopiUrl +
		'|d|' +
		serviceIdentifier() +
		'|e|' +
		props.userId +
		'|n|' +
		props.fileName +
		'|a|App';
	window.open(openInDesktopUrl);
};

const SpawnMicrosoftOfficeShareFileLogin = () => {
	const microsoftOfficeUrl = `ms-office-storage-host:asp|d|${serviceIdentifier()}|o|0|a|Web`;
	window.open(microsoftOfficeUrl);
};
export { SpawnMicrosoftOfficeWithWopi, SpawnMicrosoftOfficeShareFileLogin };
